<template>
    <div style="padding-top: 0.7rem;">
        <div style="width: 12.8rem; margin: 0 auto; padding-bottom: .24rem;border-radius: 8px;">
            <div style="margin-top: .39rem;background: #FFF;padding: .24rem;position: relative;">
                <div v-if="active == 1 && detailData.signUpId" @click="active = 0, detailData.signUpId = ''"
                    style="background: #C01A26;width: 60px;height: 30px;color: #FFF;font-size: 12px;text-align: center;line-height: 30px;border-radius: 8px;cursor: pointer;position: absolute;left: 20px;top: 30px;">
                    <span>上一步</span>
                </div>
                <div style="display: flex;justify-content: center;" class="signMsg">
                    <el-steps style="width: 80%" :active="active" simple finish-status="success">
                        <el-step title="填写报名信息" />
                        <el-step title="确认订单信息" />
                        <el-step title="购买线下课程" />
                        <el-step title="完成订单支付" />
                    </el-steps>
                </div>
                <!--  -->
                <div v-if="active == 0">
                    <div
                        style="height: .37rem;line-height: .37rem; color: #ff8741; font-size: 14px;padding-left: .12rem;background: #ffede3;border-radius: 8px;margin-top: .2rem;">
                        <span>想进一步了解课程，可以留下您的信息，会有咨询老师稍后联系您</span>
                    </div>
                    <div style="margin-top: .2rem;">
                        <el-form ref="ruleFormRef" style="" :model="ruleForm" :rules="rules" label-width="auto"
                            class="demo-ruleForm" status-icon>
                            <el-form-item label="姓名" prop="name">
                                <el-input v-model="ruleForm.name" />
                            </el-form-item>
                            <el-form-item label="手机号码" prop="phone">
                                <el-input v-model="ruleForm.phone" />
                            </el-form-item>
                            <el-form-item label="微信号" prop="wxNumber">
                                <el-input v-model="ruleForm.wxNumber" />
                            </el-form-item>
                            <el-form-item label="所在城市" prop="cityData">
                                <el-input v-model="ruleForm.cityData" />
                            </el-form-item>
                            <!-- <el-form-item label="报名人数" prop="signUpNumber">
                                <el-radio-group v-model="ruleForm.signUpNumber">
                                    <el-radio :value="1">1人</el-radio>
                                    <el-radio :value="2">2人</el-radio>
                                    <el-radio :value="3">3人及以上</el-radio>
                                </el-radio-group>
                            </el-form-item> -->
                            <el-form-item label="年龄" prop="age">
                                <el-radio-group v-model="ruleForm.age">
                                    <el-radio :value="18">18岁</el-radio>
                                    <el-radio :value="30">25-30岁</el-radio>
                                    <el-radio :value="35">30-35岁</el-radio>
                                    <el-radio :value="45">40-45岁以上</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="职业信息" prop="career">
                                <el-radio-group v-model="ruleForm.career">
                                    <el-radio value="在校学生">在校学生</el-radio>
                                    <el-radio value="在职工作者">在职工作者</el-radio>
                                    <el-radio value="创业者">创业者</el-radio>
                                    <el-radio value="其他">其他</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-form>
                        <div @click="submitForm(ruleFormRef)"
                            style="display: flex;justify-content: center;align-items: center;margin-top: .27rem;cursor: pointer;">
                            <div
                                style="height: .45rem;border-radius: 8px;background: #C01A26; color: #ffffff; font-size: 14px;line-height: .45rem;text-align: center;width: 2.68rem;">
                                <span>下一步</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div v-if="active == 1 || active == 2" style="width: 100%;">
                    <orderDetail flag="signMsg" ref="signMsgRef" @click="clickBtn" :ruleForm_Val="ruleForm" />
                </div>
                <div v-if="active == 4">
                    <finish_ :orderData="orderData" />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive } from 'vue'
import { Axios } from "../../assets/js/ls_com_axios.js";
import orderDetail from "./orderDetail"
import finish_ from "./finish_"
import { ElMessage } from "element-plus"
const ruleFormRef = ref();
const urlData = new URLSearchParams(location.search);
const signMsgRef = ref(null);
const ruleForm = ref({
    name: "",
    phone: "",
    wxNumber: "",
    cityData: "",
    signUpNumber: 1,
    age: 18,
    career: "在校学生"
})
const rules = reactive({
    name: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
    ],
    phone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        {
            required: true,
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur',
        },
    ],
    wxNumber: [
        { required: true, message: '请输入微信名称', trigger: 'blur' },
    ],
    cityData: [
        { required: true, message: '请输入地区', trigger: 'blur' },
    ],
    signUpNumber: [
        { required: true, message: '请选择报名人数', trigger: 'blur' },
    ],
    age: [
        { required: true, message: '请选择年龄', trigger: 'blur' },
    ],
    career: [
        { required: true, message: '请输入职业', trigger: 'blur' },
    ]
})
const active = ref(0);
const orderData = ref({});
const detailData = ref({});
const clickBtn = (val, item) => {
    active.value = val;

    console.log(item, active.value)
    if (item) {
        orderData.value = item;
    }
}
const getList = () => {
    Axios(
        "get",
        "/system/courseWeb/catalogue",
        {
            courseId: urlData.get('id')
        },
        false,
        (res) => {
            detailData.value = res.data.data;
            if (detailData.value.signUpId && detailData.value.orderState == 1) {
                active.value = 2;
            } else if (detailData.value.signUpId && detailData.value.orderState == 2) {
                active.value = 4;
            } else if (detailData.value.signUpId) {
                active.value = 1;
            } else {
                active.value = 0;
            }
        },
        () => {
            detailData.value = {};
        })
}
getList()

const submitForm = async (formEl) => {
    if (!formEl) return
    await formEl.validate((valid, fields) => {
        if (valid) {
            active.value = 1;
            detailData.value.signUpId = 'registered';
        } else {

        }
    })
}
</script>
<style lang="less" scoped>
/deep/.signMsg .el-step__head.is-success,
/deep/ .signMsg .el-step__title.is-success {
    border-color: #f2d1d4 !important;
    color: #C01A26 !important;
}

/deep/.signMsg .el-step__head.is-success .el-step__icon.is-text {
    background: #f2d1d4 !important;
}

/deep/.signMsg .el-step__head.is-process .el-step__icon.is-text {
    border-color: #C01A26 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
    background: #C01A26 !important;
    border-color: #C01A26 !important;
}

/deep/.el-radio__input.is-checked+.el-radio__label {
    color: #C01A26 !important;
}
</style>